import ContentMessage from 'Components/Common/Markdown/ContentMessage';
import Skeleton from 'utils/Skeleton';
import ModelProviderError from './ModelProviderError';
import useChatStore from 'Components/Chat/store';

const ContentMessageLoader = ({ message, loading, modelsIds }) => {
  const isModelProviderError = useChatStore(
    (state) => state.isModelProviderError
  );

  return (
    <>
      {isModelProviderError(message) ? (
        <ModelProviderError item={message} modelsIds={modelsIds} />
      ) : (
        <>
          <ContentMessage
            message={message?.data?.content}
            messageId={message._id}
            userType={message?.data?.role}
            originalPrompt={message?.data?.originalPrompt}
            videos={message?.videoURL}
            images={message?.imagesURL?.map((image) => ({
              ...image,
              loading: false,
            }))}
            isEditable={false}
            loading={loading}
            functionCapability={message?.data?.function}
          />
          {message.finished === false && <Skeleton />}
        </>
      )}
    </>
  );
};

export default ContentMessageLoader;
